import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { map } from 'rxjs/operators';
import { BaseAsyncValue } from '@ordersnproducts/modules/shared/models/async-value';
import { getOneClickAdditionalServicesState } from '@ordersnproducts/modules/one-click-order/selectors/one-click-additional-services.selector';

export class OneClickPreviewAdditionalServicesLoadingProvider extends BaseAsyncValue<boolean> {
  getValue(): Observable<boolean> {
    return this.store.select(getOneClickAdditionalServicesState).pipe(
      filter(state => !!state),
      map(state => state.loading),
    );
  }
}
